import styled from 'styled-components';
import ArrowIcon from 'assets/arrow-icon';
import { iconSizing, rotate } from 'styles/mixins';

export const StyledArrowIcon = styled(ArrowIcon)<{ small: boolean }>`
  ${rotate(90)};
  ${({ small }) => (small ? iconSizing.xs : iconSizing.default)};
`;
